var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('deviceBorrowItem',{staticClass:"deviceScanning",attrs:{"loaddingClass":"deviceScanning","rowKeyList":_vm.rowKeyList,"keyList":_vm.keyList,"queryType":2}})}
var staticRenderFns = []

export { render, staticRenderFns }